import $ from 'jquery';

export const getDataIdAttribute = (element: HTMLElement) => {
    return $(element).attr('data-id');
};

export const joinFormIdAndSelector = (formId: string, selector: string) => {
    return `${formId} ${buildDataIdSelector(selector)}`;
};

export const buildDataIdSelector = (dataId: string) => {
    return `[data-id="${dataId}"]`;
};
